import { useEffect, useState } from "react";
import api from "../api";

function Users() {

    const [users, setUsers] = useState([]);
    const [form, setForm] = useState({
        user: "",
        pass: "",
        role: "admin"
    });

    const fetchUsers = () => {
        api.get("/users")
            .then(res => setUsers(res.data))
            .catch(err => console.log(err));
    };

    useEffect(() => {
        fetchUsers();
    }, []);



    const handleResetPassword = (user) => {

        const newPass = prompt(`Enter new password for ${user}`);

        if (!newPass) return;

        api.put("/update-user", {
            user,
            pass: newPass
        })
            .then(() => {
                alert("Password updated");
            })
            .catch(err => {
                console.log(err);
                alert("Error updating password");
            });
    };

    const handleAdd = () => {
        if (!form.user || !form.pass) {
            alert("Fill all fields");
            return;
        }

        api.post("/add-user", form)
            .then(() => {
                setForm({ user: "", pass: "", role: "admin" });
                fetchUsers();
            });
    };


    const handleRoleChange = (user, newRole) => {

        api.put("/update-user", {
            user,
            role: newRole,
            pass: ""   // keep same password
        })
            .then(() => {
                setUsers(prev =>
                    prev.map(u =>
                        u.userid === user ? { ...u, role: newRole } : u
                    )
                );
            })
            .catch(err => {
                console.log(err);
                alert("Error updating role");
            });
    };

    const handleDelete = (user) => {
        if (!window.confirm("Delete user?")) return;

        api.delete(`/delete-user/${user}`)
            .then(() => fetchUsers());
    };

    return (
        <div style={container}>
            <h2 style={{ marginBottom: "20px" }}>User Management</h2>

            {/* ADD USER CARD */}
            <div style={card}>
                <h4 style={sectionTitle}>Add New User</h4>

                <div style={formRow}>
                    <input
                        placeholder="Username"
                        value={form.user}
                        onChange={(e) => setForm({ ...form, user: e.target.value })}
                        style={input}
                    />

                    <input
                        placeholder="Password"
                        value={form.pass}
                        onChange={(e) => setForm({ ...form, pass: e.target.value })}
                        style={input}
                    />

                    <select
                        value={form.role}
                        onChange={(e) => setForm({ ...form, role: e.target.value })}
                        style={input}
                    >
                        <option value="superadmin">Super Admin</option>
                        <option value="admin">Admin</option>
                        <option value="clerk">Clerk</option>
                        <option value="teacher">Teacher</option>
                    </select>

                    <button onClick={handleAdd} style={addBtn}>
                        + Add
                    </button>
                </div>
            </div>

            {/* USERS LIST */}
            <div style={card}>
                <h4 style={sectionTitle}>Users</h4>

                <table style={table}>
                    <thead>
                        <tr>
                            <th style={th}>User</th>
                            <th style={th}>Role</th>
                            <th style={th}>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {users.map((u, i) => (
                            <tr key={i} style={rowStyle}>
                                <td style={td}>{u.userid}</td>

                                <td style={td}>
                                    <select
                                        value={u.role}
                                        style={roleSelect}
                                        onChange={(e) => handleRoleChange(u.userid, e.target.value)}
                                    >
                                        <option value="superadmin">Super Admin</option>
                                        <option value="admin">Admin</option>
                                        <option value="clerk">Clerk</option>
                                        <option value="teacher">Teacher</option>
                                    </select>
                                </td>

                                <td style={td}>

                                    <button
                                        onClick={() => handleResetPassword(u.userid)}
                                        style={resetBtn}
                                    >
                                        Reset
                                    </button>

                                    <button
                                        onClick={() => {
                                            const token = localStorage.getItem("token");

                                            let currentUser = "";

                                            try {
                                                if (token) {
                                                    currentUser = JSON.parse(atob(token.split(".")[1])).user;
                                                }
                                            } catch (e) { }

                                            if (u.userid === currentUser) {
                                                alert("You cannot delete your own account");
                                                return;
                                            }

                                            handleDelete(u.userid);
                                        }}
                                        style={deleteBtn}
                                    >
                                        Delete
                                    </button>

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>
        </div>
    );
}

export default Users;

//////////////////////////////////////////////////////
// 🎨 STYLES
//////////////////////////////////////////////////////

const container = {
    padding: "20px",
    background: "#f4f6f9",
    borderRadius: "10px"
};

const card = {
    background: "#fff",
    padding: "15px",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    marginBottom: "20px"
};

const sectionTitle = {
    marginBottom: "10px",
    fontSize: "14px",
    color: "#374151"
};

const formRow = {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap"
};

const input = {
    padding: "8px",
    borderRadius: "6px",
    border: "1px solid #e5e7eb",
    fontSize: "13px"
};

const addBtn = {
    background: "#16a34a",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 14px",
    cursor: "pointer"
};

const deleteBtn = {
    background: "#dc2626",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "6px 12px",
    cursor: "pointer",
    fontSize: "12px"
};

const table = {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0 8px"
};

const th = {
    textAlign: "left",
    fontSize: "12px",
    color: "#6b7280",
    padding: "8px"
};

const td = {
    padding: "10px",
    background: "#fff"
};

const rowStyle = {
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    borderRadius: "8px"
};

const roleBadge = (role) => ({
    padding: "4px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: "500",
    background:
        role === "superadmin" ? "#ede9fe" :
            role === "admin" ? "#dbeafe" :
                role === "clerk" ? "#dcfce7" :
                    "#fef9c3",
    color:
        role === "superadmin" ? "#6d28d9" :
            role === "admin" ? "#1d4ed8" :
                role === "clerk" ? "#166534" :
                    "#92400e"
});

const roleSelect = {
    padding: "5px 8px",
    borderRadius: "6px",
    border: "1px solid #e5e7eb",
    fontSize: "12px",
    background: "#f9fafb"
};

const resetBtn = {
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "6px 10px",
    marginRight: "6px",
    cursor: "pointer",
    fontSize: "12px"
};